<div class="modal-content">
  <div class="modal-header">
    <h4 class="title is-size-4" translate="fomEmail.info.title"></h4>
  </div>
  <div class="modal-body">
    <p class="has-text-grey mb-4" translate="fomEmail.info.subtitle"></p>

    <app-please-be-patient></app-please-be-patient>

    <div [formGroup]="form" novalidate>
      <div class="field">
        <fino-input
          formControlName="fomEmail"
          inputAutocompleteOff
          validationIndicator
        ></fino-input>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <div class="is-flex is-centered mt-3">
      <button
        [primary]="true"
        type="button"
        [disabled]="formNotTouched"
        class="has-text-weight-bold mr-1"
        (click)="submit()"
        fino-button
        label="fomEmail.submit"
      ></button>

      <button
        type="button"
        (click)="abort()"
        class="ml-1"
        fino-button
        label="fomEmail.abort"
      ></button>
    </div>
  </div>
</div>
